import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_HiringProblem = () => (
  <DAAModuleSubtopic
    title="Randomized Algorithms - Hiring Problem"
    videos={[
      "https://www.youtube.com/embed/y8M_5n87Mzs",
      "https://www.youtube.com/embed/H0EStLKnEBI"
    ]}
    takeaways={[
      {
        text: "You interview n candidates in a sequence, and must hire or reject immediately after each interview."
      },
      {
        text: "The objective is to hire the best candidate (highest rank) while minimizing the number of hires."
      },
      {
        text: "Strategy: Hire the candidate only if they are better than all previously interviewed candidates."
      },
      {
        text: "This ensures each hire is strictly better than the previous, reducing the number of total hires."
      },
      {
        text: "Expected number of hires when candidates are in random order: O(log n)."
      },
      {
        text: "If interview cost = ci and hiring cost = ch, then total hiring cost becomes O(ch log n)."
      }
    ]}
    questions={[
      {
        text: "Write the pseudocode for solving the hiring problem. Consider the cost to interview as ci per candidate and the cost to hire the candidate is ch."
      },
      {
        text: "Analyze the performance of the Hire-Assistant algorithm when candidates are presented in random order."
      },
      {
        text: "Prove that the expected number of hires in the hiring problem is O(log n)."
      },
      {
        text: "Explain how randomization influences the efficiency of the hiring problem strategy."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DAA_HiringProblem ;
